<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <AdminRecoveryForm />
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import AdminRecoveryForm from '@/components/admin/AdminRecoveryForm.vue'

export default {
    name: 'AdminRecovery',
    components: {
        Header,
        Footer,
        AdminRecoveryForm,
    },
}
</script>
